import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Modal} from '@softline/ui-core';
import { IsoDate } from '@softline/core';

import { DateInputComponent } from '@softline/ui-core/date-input';
import { FormatPipe } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'lib-edit-due-date-dialog',
  imports: [
    DateInputComponent,
    FormatPipe,
    TranslatePipe
  ],
  templateUrl: './edit-due-date-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./edit-due-date-dialog.component.css'] })
export class EditDueDateDialogComponent implements OnInit, Modal<string | IsoDate> {
  private close!: (result: string | IsoDate) => void;

  dueDate!: string | IsoDate;

  constructor() {}

  ngOnInit(): void {}

  registerCloseHandler(handler: (result: string | IsoDate) => void): void {
    this.close = handler;
  }

  onSubmit(dueDate: string | IsoDate): void {
    this.close(dueDate);
  }
}
